<template>
    <modal name="dynamic-modal-dialog" transition="pop-out" :width="modalWidth" height="auto"
           :scrollable="true" @before-open="beforeOpen" @opened="whenOpened">
        <loading :active.sync="isLoading" :can-cancel="true" :on-cancel="onCancel" :is-full-page="fullPage"></loading>
        <div class="box">
            <div class="box-part">
                <div class="partition">
                    <div class="partition-title">{{title}}</div>
                    <b-container fluid class="form">
                        <label>Pišite nam na <strong>info@pmis.si</strong> ali izpolnite spodnji obrazec. Odzvali se vam
                            bomo v najkrajšem možnem času ter vas seznanili s pogoji za vključitev.</label>
                        <div role="group">
                            <label class="input_form">Elektronska pošta</label>
                            <b-form-input
                                    v-model="email"
                                    :state="errorEmailInputBool"
                                    placeholder="Elektronska pošta"
                                    trim>

                            </b-form-input>

                            <label class="error">
                                {{ errorEmailInputMsg }}
                            </label>
                        </div>

                        <div role="group">
                            <label class="input_form">Ime igrala</label>
                            <b-form-input
                                    v-model="appTitle"
                                    :state="errorNameInputBool"
                                    placeholder="Ime igrala"
                                    trim>

                            </b-form-input>

                            <label class="error">
                                {{ errorNameInputMsg }}
                            </label>
                        </div>

                        <div role="group">
                            <div v-for="(item, index) in valuesFunctionality" v-bind:key="item.text" class="border">
                                <label class="input_form">Funkcionalnost igrala</label>
                                <a v-if="index > 0" style="display: inline" class="right" href="#"
                                   @click="deleteFunctionalityValue(index)">
                                    <i class="fas fa-backspace myfas"></i></a>
                                <b-form-input
                                        v-model="appFunctionTitle[index]"
                                        :state="errorFunctionalityBool(index)"
                                        placeholder="Funkcionalnost igrala"
                                        trim>
                                </b-form-input>
                                <label class="input_form">Opis funkcionalnosti</label>
                                <b-form-input
                                        v-model="appFunctionDescription[index]"
                                        placeholder="Opis funkcionalnosti"
                                        trim>
                                </b-form-input>
                            </div>
                            <a href="#" @click="addFunctionalityValue()"><i class="fas fa-plus-square myfas"></i></a>
                            <font-awesome-icon :icon="['far', 'comment']" style="margin-left: 5px; width:20px; height: 20px" />
                        </div>

                        <div role="group">
                            <div v-for="(item, index) in valuesVideo" v-bind:key="item.text" class="border">
                                <label class="input_form">video predstavitev</label>
                                <a v-if="index > 0" style="display: inline" class="right" href="#"
                                   @click="deleteVideoValue(index)">
                                    <i class="fas fa-backspace myfas"></i></a>
                                <b-form-input
                                        v-model="appVideoTile[index]"
                                        placeholder="Video predstavitev"
                                        trim>
                                </b-form-input>
                                <label class="input_form">Dogodki</label>
                                <b-form-input
                                        v-model="appVideoTime[index]"
                                        placeholder="Čas dogodka [s]"
                                        trim>
                                </b-form-input>
                                <b-form-input
                                        v-model="appVideoDescription[index]"
                                        placeholder="Opis dogodka"
                                        trim>
                                </b-form-input>
                            </div>
                            <a href="#" @click="addVideoValue()"><i class="fas fa-plus-square myfas"></i></a>
                            <font-awesome-icon :icon="['far', 'comment']" style="margin-left: 5px; width:20px; height: 20px" />
                        </div>


                        <div role="group">
                            <label class="input_form">Demo račun</label>
                            <b-form-input
                                    v-model="demoAccount"
                                    :state="errorDemoAccountInputBool"
                                    placeholder="Opis ali spletna povezava"
                                    trim>
                            </b-form-input>
                        </div>

                        <div role="group">
                            <label class="input_form">Kreiranje računa</label>
                            <b-form-input
                                    v-model="createAccount"
                                    :state="errorAccounCreationInputBool"
                                    placeholder="Opis ali spletna povezava"
                                    trim>
                            </b-form-input>
                        </div>

                        <div role="group">
                            <label class="input_form">Primeri uporabe</label>
                            <b-form-input
                                    v-model="useCases"
                                    :state="errorUseCaseInputBool"
                                    placeholder="Opis ali spletna povezava"
                                    trim>
                            </b-form-input>
                        </div>

                        <div role="group">
                            <label class="input_form">Namestitev v lastnem okolju</label>
                            <b-form-input
                                    v-model="installOwn"
                                    :state="errorInstallInputBool"
                                    placeholder="Opis ali spletna povezava"
                                    trim>
                            </b-form-input>
                        </div>

                        <div role="group">
                            <div v-for="(item, index) in valuesPrecondition" v-bind:key="item.text" class="border">
                                <label class="input_form">Naziv predznanja</label>
                                <a v-if="index > 0" style="display: inline" class="right" href="#"
                                   @click="deletePreconditionValue(index)">
                                    <i class="fas fa-backspace myfas"></i></a>
                                <b-form-input
                                        v-model="appPreconditionDescription[index]"
                                        placeholder="Naziv predznanja"
                                        trim>
                                </b-form-input>
                                <label class="input_form">Spletna povezava predznanja</label>
                                <b-form-input
                                        v-model="appPreconditionUrl[index]"
                                        placeholder="Spletna povezava predznanja"
                                        trim>
                                </b-form-input>
                            </div>
                            <a href="#" @click="addPreconditionValue()"><i class="fas fa-plus-square myfas"></i></a>
                            <font-awesome-icon :icon="['far', 'comment']" style="margin-left: 5px; width:20px; height: 20px" />
                        </div>

                        <button @click="submitSolution()" class="btn btn-small solution-button" type="submit">
                            Pošlji vsebino predlaganega igrala
                        </button>

                    </b-container>
                </div>
            </div>
        </div>
    </modal>
</template>
<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import {dom, library} from '@fortawesome/fontawesome-svg-core'
    import {fas} from '@fortawesome/free-solid-svg-icons'
    import {faTwitter} from '@fortawesome/free-brands-svg-icons'
    import axios from 'axios';
    import qs from 'qs';

    library.add(fas, faTwitter);

    // Kicks off the process of finding <i> tags and replacing with <svg>
    dom.watch();

    // import JQuery from 'jquery'
    // let $ = JQuery;

    const MARGIN_FACTOR = 0.9;

    export default {
        name: 'DynamicModalDialog',
        components: {
            Loading
        },
        data() {
            return {
                valuesFunctionality: [""],
                valuesVideo: [""],
                valuesPrecondition: [""],
                items: [{
                    modalWidth: window.innerWidth * MARGIN_FACTOR,
                    titleHeight: window.innerHeight * (1 - MARGIN_FACTOR),
                }],
                email: '',
                reg: /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
                appTitle: '',
                appFunctionTitle: [],
                appFunctionDescription: [],
                appPreconditionDescription: [],
                appPreconditionUrl: [],
                appVideoTile: [],
                appVideoTime: [],
                appVideoDescription: [],
                isLoading: true,
                fullPage: false,
                title: '...',
                src: "#",
                backgroundColor: "white",
                name: '',
                demoAccount: '',
                createAccount: '',
                installOwn: '',
                useCases: ''

            }
        },
        created() {
            this.modalWidth = window.innerWidth * MARGIN_FACTOR;
            this.titleHeight = window.innerHeight * (1 - MARGIN_FACTOR);
            /*
            var v = Array.from(this.valuesFunctionality);
            console.debug(JSON.stringify(this.valuesFunctionality));
            console.debug(JSON.stringify(v));
            this.valuesFunctionality = v;
            */
        },
        methods: {
            beforeOpen(event) {
                this.title = event.params.title;
            },
            onCancel() {
                console.log('User cancelled the loader.')
            },
            whenOpened() {
                this.isLoading = false;
            },
            updateValue: function () {
                console.debug(JSON.stringify(this.values));
                this.$emit('input', this.values);
            },
            deleteFunctionalityValue: function (index) {
                this.valuesFunctionality.splice(index, 1);
                this.$emit('input', this.valuesFunctionality);
            },
            deleteVideoValue: function (index) {
                this.valuesVideo.splice(index, 1);
                this.$emit('input', this.valuesVideo);
            },
            deletePreconditionValue: function (index) {
                this.valuesPrecondition.splice(index, 1);
                this.$emit('input', this.valuesPrecondition);
            },
            addVideoValue: function () {
                this.valuesVideo.push({});
                this.$emit('input', this.valuesVideo);
            },
            addFunctionalityValue: function () {
                this.valuesFunctionality.push({});
                this.$emit('input', this.valuesFunctionality);
            },
            addPreconditionValue: function () {
                this.valuesPrecondition.push({});
                this.$emit('input', this.valuesPrecondition);
            },
            errorFunctionalityBool: function (index) {
                return this.index > 0 ? true : (this.appFunctionTitle[index] === undefined ||
                    this.appFunctionTitle[index].length < 5) ? false : true;
            },
            submitSolution: function () {
                //validate the data
                var dataNotLegit = false;

                if (!this.errorEmailInputBool || !this.errorNameInputBool || !this.errorDemoAccountInputBool ||
                    !this.errorAccounCreationInputBool || !this.errorUseCaseInputBool || !this.errorInstallInputBool ||
                    !this.errorFunctionalityBool(0))
                    dataNotLegit = true;

                if (dataNotLegit) {
                    this.$toast.open({
                        message: 'Potrebno je popraviti ali dopolniti podatke na vnosni formi.',
                        type: 'warning',
                        duration: 5000,
                        dismissible: true,
                        queue: false,
                        position: 'top',
                        onClose: this.onClose
                    });
                } else {
                    // perform POST request
                    var url = '/api/igralnica/dodaj/igralo';

                    var data = {
                        "email": this.email,
                        "title": this.appTitle,
                        "useCases": this.useCases,
                        "installOwn": this.installOwn,
                        "createAccount": this.createAccount,
                        "demoAccount": this.demoAccount,
                        "appVideoDescription" : this.appVideoDescription,
                        "appVideoTime" : this.appVideoTime,
                        "appVideoTile" : this.appVideoTile,
                        "appPreconditionUrl" : this.appPreconditionUrl,
                        "appFunctionDescription" : this.appFunctionDescription,
                        "appFunctionTitle" : this.appFunctionTitle,
                        "valuesPrecondition" : this.valuesPrecondition,
                        "valuesVideo" : this.valuesVideo,
                        "valuesFunctionality" : this.valuesFunctionality
                    };
                    const options = {
                        method: 'POST',
                        headers: {'content-type': 'application/x-www-form-urlencoded'},
                        data: qs.stringify(data),
                        url,
                    };

                    const toast = this.$toast;
                    const onClose = this.onClose;

                    axios(options).then(function (response) {
                        if (response.status == 200) {
                            toast.open({
                                message: 'Vaša rešitev je bila uspešno predlagana.',
                                type: 'success',
                                duration: 5000,
                                dismissible: true,
                                queue: false,
                                position: 'top',
                                onClose: onClose
                            });
                        } else {
                            toast.open({
                                message: 'Error' + response.status + " | " + response.statusText,
                                type: 'error',
                                duration: 5000,
                                dismissible: true,
                                queue: false,
                                position: 'top',
                                onClose: onClose
                            });
                        }
                        console.log(response.data);
                        console.log(response.status);
                        console.log(response.statusText);
                        // console.log(response.headers);
                        // console.log(response.config);
                    });
                }

                /*   'success',
                    'error',
                    'warning',
                    'info',
                    'default',

                 */

            }
        },
        computed: {
            errorEmailInputBool: function () {
                return (this.email == "") ? false : (this.reg.test(this.email)) ? true : false;
            },
            errorEmailInputMsg: function () {
                return (this.email == "") ? "" : (this.reg.test(this.email)) ? "" : "Vpišite veljaven elektronski naslov";
            },
            errorNameInputBool: function () {
                return (this.appTitle == "") ? false : this.appTitle.length > 2 ? true : false
            },
            errorNameInputMsg: function () {
                return (this.appTitle == "") ? "" : this.appTitle.length > 2 ? "" : "Dolžina naslova igrala mora biti vsaj 3 znake";
            },
            errorDemoAccountInputBool: function () {
                return (this.demoAccount == "") ? false : this.demoAccount.length > 4 ? true : false;
            },
            errorAccounCreationInputBool: function () {
                return (this.createAccount == "") ? false : this.createAccount.length > 4 ? true : false;
            },
            errorUseCaseInputBool: function () {
                return (this.useCases == "") ? false : this.useCases.length > 4 ? true : false;
            },
            errorInstallInputBool: function () {
                return (this.installOwn == "") ? false : this.installOwn.length > 4 ? true : false;
            }
        }
    }
</script>


<style lang="scss" scoped>
    .border {
        border: 2px dotted darkgray !important;
        padding: 10px;
        /*margin-bottom: 5px;*/
        margin-top: 5px;
    }

    .myfas {
        width: auto;
        height: 20px;
    }

    .right {
        text-align: right;
        float: right;
    }

    .input_form::after {
        /*content: ":";*/
    }

    div[role=group] {
        display: block;
        clear: both;
    }

    .error {
        font-weight: lighter;
        font-size: small;
        background-color: #fce4e4;
        border: 1px solid #fcc2c3;
        float: left;
        /*padding: 20px 30px;*/
    }

    .form {
        margin-top: 5px;
        margin-bottom: 5px;
        width: 100%;
    }

    label {
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #212529;
        text-align: right;
        margin: 0px;
    }

    .success {
        background-color: #4CAF50;
    }
</style>
